import {React, useState} from 'react';
import '../../App.css'
import {Grid, Box, Button, Paper, Stack, Typography} from '@mui/material';
import { ArrowForwardIos, Addchart} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import Notification from '../Notification';

const initialFValues={
  id: 0,
  filePath: '',
  mailTo: '',
}

function EmailSendForm(){

  const [values, setValues] = useState(initialFValues);
  const [fileData, setFileData] = useState();
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
    const [notify, setNotify] = useState({isOpen: false, message: '', type: ''});

  const validate = () => {
    let temp = {}
    temp.mailTo = values.mailTo ? "" : "This field is required."

    setErrors({
      ...temp
    })

    return Object.values(temp).every(x => x == "")
  }

  const resetForm = () => {
    setValues(initialFValues);
    setErrors({});
  }

  function handleFileChange(e) {
    setFileData(e.target.files[0]);
  }

  function handleInputChange(e){
    const {name, value} = e.target;
    setValues({
      ...values,
      [name]: value
    })
  }


  const handleSubmit = (e) => {
    e.preventDefault();
    if(validate()){
      const data = new FormData();
      data.append('attachment', fileData);
      data.append('mailTo', values.mailTo);
      fetch(`${process.env.REACT_APP_API_BASE_URL}/create-payroll/payslip-send-mail`, {
        method: 'POST',
        body: data,
        credentials: 'include',
      })
      .then((result) => {
        const json = result.json();  
        if(result.status === 200) {
          setNotify({
            isOpen: true,
            message: "Successfully Sent Email!",
            type: 'success'
          });
        } else {
          setNotify({
            isOpen: true,
            message: json.message || 'Some error has occured at Server',
            type: 'error'
          });
        }
      })
      .catch((e) => {
      })
    }
  }

  return(
    <>
    <Box sx={{display: "flex" ,justifyContent: "center", margin: "10px", padding: "50px", fontWeight: "500px"}}>
      <Paper variant="outlined" elevation={5} >
        <Grid className="form-title" container spacing={2}>
          <Grid item> <Typography variant="h5" sx={{textAlign: "center", margin: 5}}>Insert Header</Typography> </Grid>
          <Grid item> <Addchart sx={{width: 45, height: 45}}/> </Grid>
        </Grid>
        <form onSubmit={handleSubmit}>
          <Stack spacing={2} sx={{margin: "30px"}}>

          <div class="mb-3">
            <label for="formFile" class="form-label">To:</label>
            <input autoComplete='off' name="mailTo" value={values.mailTo} class="form-control" type="input" onChange={handleInputChange}/>
          </div>

          <div class="mb-3">
            <label for="formFile" class="form-label">Select a file:</label>
            <input name="filePath" class="form-control" type="file" onChange={handleFileChange}/>
          </div>


                  
               
            <div display="flex" sx={{alignItems: "flex-end"}} style={{display: "flex", alignItems: "center",justifyContent : "end"}}>
             
                    <Button variant="contained" color="warning" onClick={()=> navigate('/create-payroll')}>Back</Button>
                  &nbsp;&nbsp;
                <Button variant="contained" endIcon={<ArrowForwardIos />} type="submit">Send</Button>
            </div>

            </Stack>
            {/* <input type="file" onChange={handleFileChange} />
            <button type="submit">Submit</button> */}
        </form>


      </Paper>
      
    </Box>
      <Notification
          notify={notify}
          setNotify={setNotify} 
      />
    </>
  )
}

export default EmailSendForm;
